module.exports = __webpack_public_path__ + "img/plan3_book08.18a1a156.png";